import background from '@/assets/emptystate_background.svg';

export const styles = {
  overlay: {
    backgroundImage: `url(${background})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '8px',
    height: '39.8rem',
    padding: '1rem',
    '@media (max-width: 600px)': {
      height: '24.9rem',
    },
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    maxWidth: '600px',
    minWidth: '312px',
    minHeight: '156px',
    boxSizing: 'border-box',
    textAlign: 'center',
  },
  title: {
    fontSize: '1.8rem',
    textAlign: 'center',
    color: 'white',
    fontWeight: 600,
  },
  description: {
    fontSize: '1.6rem',
    textAlign: 'center',
    color: '#fff',
  },
};
